import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Gabriel
 * id 05B8E566-B224-4ECC-AE70-2BF8BE90C82A
 * name close-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-box-outline.svg
 * tags
 * - Math 
 * - Form 
 */
export const CloseBoxOutlineIcon = createSvgIcon(<><path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,8.4L13.4,12L17,15.6L15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4Z" /></>, 'CloseBoxOutlineIcon');
export default CloseBoxOutlineIcon